/* eslint-disable no-param-reassign */
import { getMobileOperatingSystem } from 'app/utils/browser';
import { isDesktop } from 'app/utils/resolution';

/* */
const googleStoreButtonNode = document.getElementById('googleplay-footer-button');
const appleStoreButtonNode = document.getElementById('appstore-footer-button');


const setHiddenElement = (node, condition) => {
    const prop = condition ? 'block' : 'none';
    if (!node) return null;
    node.style.display = prop;
};

/**
 * @description Отображает кнопку с ссылкой на магазин в footer'e в зависимости от типа мобильной os
 */
export const displaySpecificStoreButton = () => {
    if (!isDesktop()) {
        const { android, ios } = getMobileOperatingSystem();
        setHiddenElement(googleStoreButtonNode, android);
        setHiddenElement(appleStoreButtonNode, ios);
    }
};
